import Vue from "vue";
import axios from "axios";

const MinervaData = new Vue({
  data() {
    return {};
  },
  created() {},
  methods: {
    fetchData(make) {
      if (!make) {
        console.error("Make is required to fetch Minerva data.");
        return Promise.reject("Make is required"); // Devuelve una promesa rechazada
      }

      const minervaEndpoint =
        "https://saminervajsonprod.blob.core.windows.net/minerva/";

      return axios
        .get(`${minervaEndpoint}${make}.json`)
        .then((response) => {
          return response.data.models; // Esto será el resultado de la promesa
        })
        .catch((error) => {
          console.error("Error fetching Minerva data:", error);
          throw error; // Propaga el error para que el .catch() externo lo capture
        });
    },
  },
});

export default MinervaData;
